import { Navigate, Outlet, useLocation } from "react-router-dom"
import { AuthStorage } from "../../utils/auth/AuthStorage"

type ProtectedRouteProps = {
  isLoginRoute?: boolean
}

export function ProtectedRoute(props: ProtectedRouteProps) {
  const location = useLocation()
  const isLoggedIn = AuthStorage.isTokenValid()

  // Se o token for inválido ou expirado, limpa o localStorage
  if (!isLoggedIn && AuthStorage.getAccessToken()) {
    AuthStorage.clearAccessToken()
  }

  // Se o usuário está autenticado
  if (isLoggedIn) {
    // Se está tentando acessar a rota de login, redireciona para home
    if (props.isLoginRoute) {
      return <Navigate to="/" replace />
    }

    return <Outlet />
  }

  // Se a rota é a de login e não está autenticado, permite acesso
  if (props.isLoginRoute) {
    return <Outlet />
  }

  // Não autenticado tentando acessar rota protegida, redireciona para login
  return <Navigate to="/login" state={{ from: location.pathname }} replace />
}